import { render, staticRenderFns } from "./generalSetting.vue?vue&type=template&id=72d84b54"
import script from "./generalSetting.vue?vue&type=script&lang=js"
export * from "./generalSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports